import { RegistrationInfo, UserInfo, UserState } from '@/utils/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
	attendee: localStorage.getItem('attendee') ? JSON.parse(localStorage.getItem('attendee')!) : null,
	eventId: localStorage.getItem('eventId'),
};

const attendeeSlice = createSlice({
	name: 'attendee',
	initialState,
	reducers: {
		setRegistrationData: (state, { payload }: PayloadAction<RegistrationInfo>) => {

			localStorage.setItem('attendee', JSON.stringify(payload.attendee));
			localStorage.setItem('eventId', payload.eventId);
			return { ...state, attendee: payload.attendee, eventId: payload.eventId };
		},
		clearRegistrationData: (state) => {
			localStorage.clear();
			return { attendee: null, eventId: null };
		},
	},
});
export const { setRegistrationData, clearRegistrationData } = attendeeSlice.actions;
export default attendeeSlice;
